/**
 * Created by Abner Sui on 04/04/2019.
 * Description:
 * ------ maintenance history ------
 * Updated by Daniel on 7/10/2023, added alignment property for all columns
 */

import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Alignment, TileColumn, TileColumnDataType } from '../../../../tamalelibs/models/tile-column.model';
import { BriefConfig } from '../../../../widgets/widgets.model';
import { TileModel } from '../../../../tamalelibs/models/tile.model';
import { BriefObject } from '../../../../tamalelibs/models/brief-object';
import { Subscription } from 'rxjs';

@Component({
    selector: 'tam-tile-column',
    templateUrl: './tile-column.component.html',
    styleUrls: ['./tile-column.component.scss']
})
export class TileColumnComponent implements OnInit, OnDestroy {

    @Input() config: TileColumn;
    @Input() wholeConfig: TileModel;
    @Input() briefConfig: BriefConfig;

    alignmentList: Array<BriefObject> = [
        { id: 'right', value: 'Right' },
        { id: 'left', value: 'Left' }
    ];
    selectedAlignment: BriefObject;

    private _destroySubscriptions: Array<Subscription> = [];

    constructor() { }

    ngOnInit(): void {
        if (this.config.alignment) {
            this.selectedAlignment = this.alignmentList.find(item => item.id === this.config.alignment);
        } else {
            if (this.config.dataType === TileColumnDataType.CURRENCY ||
                this.config.dataType === TileColumnDataType.NUMBER ||
                this.config.dataType === TileColumnDataType.PERCENT ||
                this.config.dataType === TileColumnDataType.RATIO) {
                this.selectedAlignment = { id: 'right', value: 'Right' };
                this.config.alignment = Alignment.RIGHT;
            } else {
                this.selectedAlignment = { id: 'left', value: 'Left' };
                this.config.alignment = Alignment.LEFT;
            }
        }

        this._destroySubscriptions.push(
            this.briefConfig.feedbackSubject$.subscribe(response => {
                if (response) {
                    this.selectedAlignment = { id: 'right', value: 'Right' };
                    this.config.alignment = Alignment.RIGHT;
                }
            })
        );
    }

    ngOnDestroy(): void {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    onAlignmentChange(event) {
        this.selectedAlignment = event;
        this.config.alignment = this.selectedAlignment.id;
    }

    onShowColumnChange(value) {
        this.config.hidden = !value;
    }
}
